__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-31-1788154892-stable-dev/";